let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2Q4bo"), load("bzc8Q"), load("kyfJT")]).then(() => parcelRequire('dhbEh'));